import React from 'react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const footerContent = {
  brandName: 'HABITANDOMICUERPO',
  copyright: '© 2024 HABITANDOMICUERPO. Todos los derechos reservados.',
  disclaimer: 'Este sitio no es parte del sitio web de Facebook o Facebook Inc. Además, este sitio NO está respaldado por Facebook de ninguna manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.',
  links: [{
    label: 'Términos y Condiciones',
    href: '#'
  }, {
    label: 'Política de Privacidad',
    href: '#'
  }, {
    label: 'Contacto',
    href: '#'
  }]
};
export function Footer() {
  return <footer className="bg-[#050505] py-12 px-4 border-t border-brand-cardBorder" data-id="element-101">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-102">
        <h3 className="text-2xl font-serif text-brand-light mb-6" data-id="element-103">
          {footerContent.brandName}
        </h3>

        <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-104">
          {footerContent.links.map((link, index) => <a key={index} href={link.href} className="text-brand-light/50 hover:text-brand-light transition-colors font-sans text-sm" data-id="element-105">
              {link.label}
            </a>)}
        </div>

        <p className="text-brand-light/40 text-xs font-sans max-w-2xl mb-4 leading-relaxed" data-id="element-106">
          {footerContent.disclaimer}
        </p>

        <p className="text-brand-light/30 text-xs font-sans" data-id="element-107">
          {footerContent.copyright}
        </p>
      </div>
    </footer>;
}